import axios from 'axios';

const list = (data) => axios.get('/logist/safe/list', data);
const save = (data) => axios.post('/logist/safe/save', data);
const del = (data) => axios.post('/logist/safe/delete', data); //delete

export default {
  list,
  save,
  del,
}


